// src/app/(extras)/blog/layout.tsx
"use client";
import { BlogTransitionOverlay } from "@/components/blog/BlogTransitionOverlay";

export default function BlogLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<div className="blog-layout">
			<BlogTransitionOverlay />
			{/* Custom styles for blog content */}
			<style jsx global>{`
        .blog-content h1 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          color: #1a202c;
          font-family: var(--font-jost);
        }

        .blog-content h2 {
          font-size: 1.875rem;
          font-weight: 700;
          margin-top: 2rem;
          margin-bottom: 1rem;
          color: #1a202c;
          font-family: var(--font-jost);
        }

        .blog-content h3 {
          font-size: 1.5rem;
          font-weight: 600;
          margin-top: 1.75rem;
          margin-bottom: 0.75rem;
          color: #1a202c;
          font-family: var(--font-jost);
        }

        .blog-content p {
          margin-bottom: 1.25rem;
          line-height: 1.8;
          color: #4a5568;
        }

        .blog-content ul,
        .blog-content ol {
          margin-bottom: 1.25rem;
          padding-left: 1.5rem;
        }

        .blog-content li {
          margin-bottom: 0.5rem;
          line-height: 1.7;
          color: #4a5568;
        }

        .blog-content ul li {
          list-style-type: disc;
        }

        .blog-content ol li {
          list-style-type: decimal;
        }

        .blog-content a {
          color: #dc2626;
          text-decoration: underline;
        }

        .blog-content a:hover {
          color: #991b1b;
        }

        .blog-content blockquote {
          border-left: 4px solid #dc2626;
          padding-left: 1rem;
          margin-left: 0;
          margin-right: 0;
          margin-bottom: 1.5rem;
          font-style: italic;
          color: #718096;
        }

        .blog-content code {
          font-family: monospace;
          background-color: #f7fafc;
          padding: 0.2rem 0.4rem;
          border-radius: 0.25rem;
          font-size: 0.875rem;
          color: #805ad5;
        }

        .blog-content pre {
          background-color: #18181b;
          color: #e2e8f0;
          padding: 1rem;
          border-radius: 0.5rem;
          overflow-x: auto;
          margin-bottom: 1.5rem;
        }

        .blog-content pre code {
          background-color: transparent;
          color: inherit;
          padding: 0;
          font-size: 0.875rem;
        }

        .blog-content img {
          max-width: 100%;
          height: auto;
          border-radius: 0.5rem;
          margin: 2rem 0;
        }

        .blog-content hr {
          margin: 2.5rem 0;
          border: 0;
          border-top: 1px solid #27272a;
        }

        .blog-content table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1.5rem;
        }

        .blog-content th,
        .blog-content td {
          padding: 0.75rem;
          border: 1px solid #e2e8f0;
        }

        .blog-content th {
          background-color: #f7fafc;
          font-weight: 600;
          text-align: left;
        }

        .blog-content strong {
          font-weight: 600;
          color: #1a202c;
        }

        .blog-content em {
          font-style: italic;
        }
      `}</style>
			{children}
		</div>
	);
}
